import CIMSTable from 'components/CIMSTable'
import { useOrganizationsTableContext } from '../../OrganizationsTableContext'
import { useColumns } from './hooks/useColumns'
import { useCreateOptions } from './hooks/useCreateOptions'
import { useEditOptions } from './hooks/useEditOptions'
import { useExpandOptions } from './hooks/useExpandOptions'
import { useRemoveOptions } from './hooks/useRemoveOptions'
import { useRestore } from './hooks/useRestoreOptions'

export const OrganizationsTable: React.FC = () => {
  const { records, refetch, fetching } = useOrganizationsTableContext()

  return (
    <CIMSTable
      rowKey={'id'}
      loading={fetching}
      records={records}
      columns={useColumns()}
      actions={{
        header: { create: useCreateOptions(), onReload: refetch },
        row: {
          edit: useEditOptions(),
          restore: useRestore(),
          remove: useRemoveOptions(),
        },
      }}
      expand={useExpandOptions()}
    />
  )
}
